/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Kpi_Avg_Order_ValueInputs */

const vi_report_kpi_avg_order_value = /** @type {(inputs: Report_Kpi_Avg_Order_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị trung bình`)
};

/**

* @param {Report_Kpi_Avg_Order_ValueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_kpi_avg_order_value = /** @type {((inputs?: Report_Kpi_Avg_Order_ValueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Kpi_Avg_Order_ValueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_kpi_avg_order_value(inputs)
});